import React from "react";
import { Button, Popover } from "antd";

const TableRowActionsButton = ({ menu }) => (
  <Popover content={menu} placement="bottomRight">
    <Button icon="interaction" type="primary" shape="circle" />
  </Popover>
);

export default TableRowActionsButton;
